import { Moment } from 'moment';
import * as moment from 'moment-timezone';

export class PayrollScheduleInfo {
  private _utcDate: any;
  closed: boolean;

  get utcDate(): Moment {
    return moment.utc(this._utcDate);
  }

  set utcDate(date: Moment) {
    this._utcDate = date;
  }

  constructor(init?: Partial<PayrollScheduleInfo>) {
    Object.assign(this, init);
  }
}

export class PayrollSchedule {

  private _minDateUtc: any;
  private _maxDateUtc: any;
  private _defaultDate: Moment;

  schedule: PayrollScheduleInfo[];

  get minDateUtc(): Moment {
      return moment.utc(this._minDateUtc);
  }

  set minDateUtc(date: Moment) {
      this._minDateUtc = date;
  }

  get maxDateUtc(): Moment {
    return moment.utc(this._maxDateUtc);
  }

  set maxDateUtc(date: Moment) {
    this._maxDateUtc = date;
  }

  constructor(init?: Partial<PayrollSchedule>) {
    if (init) {
      this.minDateUtc = init.minDateUtc;
      this.maxDateUtc = init.maxDateUtc;
      if (init.schedule) {
        this.schedule = init.schedule.map(s => new PayrollScheduleInfo(s));
      }
    }
    this._defaultDate = null;
  }

  /*
  Default PayDate rules https://ultidev/browse/ULTI-373557
  1) the payroll with the current date or future date that has at least one pay group closed that is nearest to the current date OR
  2) If no future date exists, the payroll with a past date that has at least one pay group closed that is nearest to the current date OR
  3) If no payrolls have been closed, default open payrolls with current or future date closest to current date OR
  4) If no future date exists, default open payroll with past date that is closest to current date.
  */

  getDefaultPayrollDate(): Moment {
    if (!this.schedule) {
      return null;
    }

    if (!this._defaultDate) {
      const closedPayrolls = this.schedule.filter(p => p.closed);
      this._defaultDate = closedPayrolls && closedPayrolls.length > 0
        ? this._getDefaultPayrollDate(closedPayrolls)
        : this._getDefaultPayrollDate(this.schedule);

      if (!this._defaultDate) {
        const today = moment()
          .tz('America/New_York')
          .startOf('day')
          .utc();
        this._defaultDate = moment.min(moment.max(this.minDateUtc, today), this.maxDateUtc);
      }
    }
    return this._defaultDate;
  }

  private _getDefaultPayrollDate(schedule: PayrollScheduleInfo[]): Moment {

    const prevDates = [];
    const nextDates = [];
    const today = moment().utc().startOf('day');
    schedule.forEach(p => {
      const duration = moment.duration(p.utcDate.diff(today)).asDays();
      if (duration >= 0) {
        nextDates.push(p.utcDate);
      } else {
        prevDates.push(p.utcDate);
      }
    });
    if (nextDates.length > 0) {
      return moment.min(nextDates);
    }
    if (prevDates.length > 0) {
      return moment.max(prevDates);
    }
    return null;
  }
}
